module.exports = __webpack_public_path__ + "img/title-.126ef270.png";